// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__eP5jl","title":"AfterFrontImage_title__zsPbN"};